import { render } from "./feature-group-attachment.vue?vue&type=template&id=d03205b0"
import script from "./feature-group-attachment.vue?vue&type=script&lang=js"
export * from "./feature-group-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__